import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { LoginApiClient, createDefaultHttpParams } from '../login-api-client';
import { PlainHttpParams } from '@monsido/http/params';
import { firstValueFrom } from 'rxjs';

export interface BulkDeleteRequest {
    emails: string[];
    all_envs: boolean;
}

export interface BulkDeleteResponse {
    deleted_count: number;
    failed_count: number;
    errors?: string[];
}

@Injectable({
    providedIn: 'root',
})
export class LoginUserRepo {
    constructor (private loginClient: LoginApiClient) {}

    /**
     * Bulk delete users using the login API
     * @param emails Array of email addresses to delete
     * @param allEnvs Whether to delete from all environments
     * @param urlPrefix Optional URL prefix (e.g., "https://login.staging.monsido.com/")
     * @param params Optional query parameters
     * @param headers Optional HTTP headers
     * @returns Promise resolving to bulk delete response
     */
    async bulkDelete (
        emails: string[],
        allEnvs: boolean = true,
        urlPrefix?: string,
        params?: PlainHttpParams,
        headers?: HttpHeaders,
    ): Promise<BulkDeleteResponse> {
        const body: BulkDeleteRequest = {
            emails: emails,
            all_envs: allEnvs,
        };

        if (urlPrefix) {
            this.loginClient.setUrlPrefix(urlPrefix);
        }

        const options = createDefaultHttpParams(params, headers);

        // Use deleteObservable with body support for bulk deletion
        return firstValueFrom(
            this.loginClient.deleteObservable('api/v1/users_bulk', {
                ...options,
                // @ts-expect-error - Adding body to delete request
                body: body,
            }),
        );
    }
}
